import React, {useMemo} from 'react';
import {Stack, Typography} from '@mui/material';
import {buildCitationsByMaterial, citationsCountsText} from '../buildCollectionCoverageView';
import CollectionMaterialRow from './CollectionMaterialRow';

/**
 * Citations tab: citations grouped by the cited CM/IIR (owner decision) —
 * one group per cited material with the citing FINTELs linked under it.
 * With no citations, the tab shows only "No citations found".
 */
export default function CollectionCitationsTab({view, onOpenMaterial, onOpenReport}) {
    const groups = useMemo(() => buildCitationsByMaterial(view), [view]);

    if (groups.length === 0) {
        return (
            <Typography variant="body2" color="text.secondary">
                No citations found
            </Typography>
        );
    }

    return (
        <Stack spacing={2}>
            <Typography variant="body2" fontWeight={600}>
                {citationsCountsText(view)}
            </Typography>
            <Stack spacing={1}>
                {groups.map(({material}) => (
                    <CollectionMaterialRow
                        key={material.id}
                        material={material}
                        showCitingFintels
                        onOpen={onOpenMaterial}
                        onOpenReport={onOpenReport}
                    />
                ))}
            </Stack>
        </Stack>
    );
}
